import { render, staticRenderFns } from "./RegistryEditField.vue?vue&type=template&id=67675dec"
import script from "./RegistryEditField.vue?vue&type=script&lang=js"
export * from "./RegistryEditField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-apistage/apistage.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67675dec')) {
      api.createRecord('67675dec', component.options)
    } else {
      api.reload('67675dec', component.options)
    }
    module.hot.accept("./RegistryEditField.vue?vue&type=template&id=67675dec", function () {
      api.rerender('67675dec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/registry/RegistryEditField.vue"
export default component.exports